module.exports = __webpack_public_path__ + "img/journey.f9c20aab.svg";